import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MenuItemCatalog, MenuItemCatalogPrice, Allergen, MenuItemBulletList } from 'src/app/models/rich-data.model';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';
import { IonSlides } from '@ionic/angular';


@Component({
  selector: 'app-catalog-item-detail-page',
  templateUrl: './catalog-item-detail-page.component.html',
  styleUrls: ['./catalog-item-detail-page.component.scss'],
})
export class CatalogItemDetailPageComponent implements OnInit {
  @ViewChild('slides') slides: IonSlides;
  @Input() item: MenuItemCatalog;
  @Input() price: MenuItemCatalogPrice;
  userLang: string;
  allergens: Allergen[] = [];
  bulletList: MenuItemBulletList[] = [];

  sliderOpts = {
    speed: 300, //0.3s transition
    autoplay: { delay: 5000, active: true, speed: 700 },
    slidesPerView: 1
  };

  constructor(public dataServ: DataService,
    private modalCntrl: ModalController,
    public authServ: AuthService,
    public modalServ: ModalMakerService) { }

  async ngOnInit() {
    this.userLang = localStorage.getItem('userLang');
    if (typeof this.item.allergen_codes !== undefined && this.item.allergen_codes !== '' && this.item.allergen_codes !== null) {
      this.allergens = JSON.parse(this.item.allergen_codes);
    }

    if (this.authServ.isLogged) {
      this.bulletList = await this.dataServ.getCatalogBulletList(this.item);
    }
  }

  async ionViewDidEnter() {
    this.slides.update();
  }

  closeModal() {
    this.modalCntrl.dismiss();
  }

}
